const FINDING_DISPOSITION = Object.freeze({
  UNTRIAGED: 'UNTRIAGED',
  IN_PROGRESS: 'IN_PROGRESS',
  RESOLVED: 'RESOLVED',
  MUTED: 'MUTED',
  DISMISSED: 'DISMISSED',
});

const HIDDEN_FINDING_DISPOSITIONS = Object.freeze([
  FINDING_DISPOSITION.MUTED,
  FINDING_DISPOSITION.DISMISSED,
]);

const FINDING_DISPOSITION_SET = new Set(Object.values(FINDING_DISPOSITION));

function normalizeFindingDisposition(value) {
  if (value == null || value === '') return null;
  const normalized = String(value).trim().toUpperCase().replace(/[\s-]+/g, '_');
  if (normalized === FINDING_DISPOSITION.UNTRIAGED || normalized === 'OPEN' || normalized === 'NONE') {
    return null;
  }
  return FINDING_DISPOSITION_SET.has(normalized) ? normalized : null;
}

function isHiddenFindingDisposition(value) {
  return HIDDEN_FINDING_DISPOSITIONS.includes(normalizeFindingDisposition(value));
}

function squidlerFindingDisposition(value) {
  return normalizeFindingDisposition(value);
}

function visibleProviderProblemWhere(includeHiddenDispositions = false) {
  if (includeHiddenDispositions) return {};
  return {
    OR: [
      { disposition: null },
      { disposition_not_in: [...HIDDEN_FINDING_DISPOSITIONS] },
    ],
  };
}

function visibleProviderObservationWhere(includeHiddenDispositions = false) {
  if (includeHiddenDispositions) return {};
  return {
    OR: [
      { providerProblem: { disposition: null } },
      { providerProblem: { disposition_not_in: [...HIDDEN_FINDING_DISPOSITIONS] } },
    ],
  };
}

module.exports = {
  FINDING_DISPOSITION,
  HIDDEN_FINDING_DISPOSITIONS,
  normalizeFindingDisposition,
  isHiddenFindingDisposition,
  squidlerFindingDisposition,
  visibleProviderProblemWhere,
  visibleProviderObservationWhere,
};
